/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import GroupType from '@linc-technologies/linced-common/enums/group-type';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class IdeRoute extends Route {
  // Services
  @service
  store;

  model() {
    let year = moment().format('YYYY');

    return hash({
      homerooms: this.store.query('group', {
        groupType: GroupType.HOMEROOM,
        year: year,
      }),
      learners: this.store.query('person', {
        type: PersonType.LEARNER,
        include: 'enrolments',
      }),
      staff: this.store.query('person', { type: PersonType.STAFF }),
    });
  }
}
